import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';

import store from './store';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "components/Common/ScrollToTop ";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollToTop />
        <App />
    </BrowserRouter>
  </Provider>
);
